/**
 * Created by spepa on 24.04.2023
 */

const PromotionSaleLot = cc.Scale9Sprite.extend({
    ctor: function (lot, logic) {
        this.bundle = bundles[logic.offer.bundle];

        this._super(this.bundle.frames.tile_bg, cleverapps.UI.getScale9Rect(this.bundle.frames.tile_bg, cleverapps.UI.Scale9Rect.TwoPixelXY));
        this.setContentSize2(cleverapps.styles.PromotionSaleLot[logic.offer.type]);

        this.lot = lot;
        this.logic = logic;
        this.product = logic.getProduct(lot);

        this.createRewards();
        this.createBadge();
        this.createButton();

        this.updateState();

        cleverapps.paymentsLogic.onChangeStatus(this.updateState.bind(this), this);

        this.logic.onLotPurchaseFinished[this.lot.id] = this.createListener((success) => {
            if (success) {
                this.receiveRewards();
            } else {
                this.updateState();
            }
        });
    },

    createRewards: function () {
        const styles = cleverapps.styles.PromotionSaleLot[this.logic.offer.type].reward;

        const rewardBg = cleverapps.UI.createScale9Sprite(this.bundle.frames.reward_title, cleverapps.UI.Scale9Rect.TwoPixelXY);
        rewardBg.setContentSize2(styles);

        const rewardsList = this.rewardsList = new RewardsListComponent(this.lot.reward, {
            font: cleverapps.styles.FONTS.BONUSSALE_PRODUCT_REWARD,
            columns: "auto",
            fitToBox: {
                width: styles.width,
                height: styles.height
            },
            noPrefix: false,
            reverseRows: true,
            margin: styles.margin,
            textMargin: styles.textMargin,
            iconWrap: styles.icons.wrap,
            textDirection: cleverapps.UI.VERTICAL,
            event: cleverapps.EVENTS.EARN.PURCHASE
        });

        rewardsList.setAlignment(styles.icons);
        rewardBg.addChild(rewardsList);

        rewardBg.setAlignment(styles);
        this.addChild(rewardBg);
    },

    createBadge: function () {
        const styles = cleverapps.styles.PromotionSaleLot[this.logic.offer.type].badge;
        const badge = new TileBadge({
            rotation: styles.rotation,
            type: "discount",
            text: this.lot.profit,
            largeFont: true
        });
        badge.setAlignment(styles);
        this.addChild(badge);
    },

    createButton: function () {
        const styles = cleverapps.styles.PromotionSaleLot[this.logic.offer.type].button;
        const button = this.button = new cleverapps.UI.Button({
            text: this.product.getCurrentPrice(),
            onClicked: this.buyProduct.bind(this),
            width: cleverapps.styles.PromotionSaleLot[this.logic.offer.type].button.width,
            height: cleverapps.styles.PromotionSaleLot[this.logic.offer.type].button.height
        });

        button.setAlignment(styles);
        this.addChild(button);
    },

    buyProduct: function () {
        this.logic.buyLot(this.lot);
    },

    receiveRewards: function () {
        this.rewardsList.receiveRewards();
        this.rewardsList.receiveRewardsAnimation();
    },

    updateState: function () {
        const available = this.product.isAvailable();

        this.button.setString(this.product.getCurrentPrice());

        if (this.logic.isDisabled(this.lot.id) || !available) {
            this.button.disable();

            if (this.clickHandler) {
                this.clickHandler.remove();
                this.clickHandler = undefined;
            }

            if (this.button.lotteryIcon) {
                this.button.lotteryIcon.removeFromParent();
            }
        } else if (available) {
            if (!this.clickHandler) {
                this.clickHandler = cleverapps.UI.onClick(this, this.buyProduct.bind(this));
            }
            this.button.enable();
        }

        if (this.logic.isSoldLot(this.lot.id)) {
            this.button.setString(Messages.get("SoldOut"));
        }
    }
});

cleverapps.overrideFonts(cleverapps.styles.FONTS, {
    BONUSSALE_PRODUCT_REWARD: {
        name: "nostroke",
        size: 40,
        color: cleverapps.styles.COLORS.DARK_TEXT_COLOR
    },

    BONUSSALE_BADGE: {
        size: 30,
        color: cleverapps.styles.COLORS.LIGHT_TEXT_COLOR,
        shadow: cleverapps.styles.DECORATORS.LIGHT_TEXT_SHADOW
    }
});

cleverapps.styles.PromotionSaleLot = {};
cleverapps.styles.PromotionSaleLot[Offers.TYPES.PROMOTION_SALE] = {
    width: 450,
    height: 670,

    reward: {
        width: 410,
        height: 510,

        x: { align: "center", dx: 0 },
        y: { align: "center", dy: 60 },

        margin: {
            x: 10,
            y: 20
        },

        textMargin: -10,

        icons: {
            x: { align: "center" },
            y: { align: "center" },
            wrap: {
                width: 160,
                height: 160
            }
        }
    },

    badge: {
        x: { align: "right", dx: 70 },
        y: { align: "top", dy: 10 },
        rotation: 0
    },

    button: {
        width: 300,

        x: { align: "center" },
        y: { align: "bottom", dy: 26 }
    }
};
cleverapps.styles.PromotionSaleLot[Offers.TYPES.CLPROMOTION_SALE] = cleverapps.styles.PromotionSaleLot[Offers.TYPES.PROMOTION_SALE];
